// export const API_BASE_URL_NEW = "http://localhost:3000";

// export const API_BASE_URL = "http://localhost:3000";

export const API_BASE_URL = "https://node-airdrop.bingold.to";

export const API_BASE_URL_NEW = "https://node-airdrop.bingold.to";

export const LOCALSTORAGES = {
  TOKEN: "udx_k_01_tkn",
  USER: "user",
};

export const DASHBOARD_PATH = {
  ROOT: "/dashboard",
  ALL_CAMPAIGNS: "/dashboard/all-campaigns",
  ALL_Private_CAMPAIGNS: "/dashboard/all-campaigns-private",
  ALL_List_CAMPAIGNS: "/dashboard/list-campaigns",
  ALL_List_Codes: "/dashboard/list-codes",

  INDIVIDUAL_CAMPAIGN: "/dashboard/individual-campaign",
  CLAIM_HISTORY: "/dashboard/claim-history",
  PORFILE_SETTINGS: "/dashboard/profile-settings",
  ACTIVE_CAMPAIGNS: "/dashboard/active-campaigns",
  RECOMMENDED_CAMPAIGNS: "/dashboard/recommended-campaigns",
  MORE_CLAIMS: "/dashboard/more-claims",
  VIEW_LOG: "/dashboard/view-log",
  REFFERAL: "/dashboard/refferal",
};

// const DASHBOARD_BASE = "/dashboard";

// export const DASHBOARD_ROUTES = {
//   DASHBOARD: `${DASHBOARD_BASE}`,
//   CAMPAIGNS: `${DASHBOARD_BASE}/campaigns`,
//   CAMPAIGNS_NEW: `${DASHBOARD_BASE}/campaigns/new`,
//   CAMPAIGNS_DETAIL: (id: string) => `${DASHBOARD_BASE}/campaigns/${id}`,
//   CAMPAIGNS_EDIT: (id: string) => `${DASHBOARD_BASE}/campaigns/${id}/edit`,
//   USERS: `${DASHBOARD_BASE}/users`,
//   TRANSACTIONS: `${DASHBOARD_BASE}/transactions`,
//   WALLETS: `${DASHBOARD_BASE}/wallets`,
//   FINANCIAL: `${DASHBOARD_BASE}/financial`,
//   SETTINGS: `${DASHBOARD_BASE}/settings`,
// };

export const AUTH_API_ENDPOINT = {
  SIGNIN: "/api/v1/user/login",
  SEND_OTP: "/api/v1/user/sendOtp",
  VERIFY_OTP: "/api/v1/user/verifyOTP",
  RESEND_OTP: "/api/v1/admin/resendOtp",
  FORGOT_PASSWORD: "/api/v1/admin/forgotPassword",
  RESET_PASSWORD: "/api/v1/admin/resetPassword",
  CHANGE_PASSWORD: "/api/v1/admin/changePassword",
  GET_PROFILE: "/api/v1/user/getProfile",
  UPDATE_PROFILE: "/api/v1/admin/editProfile",
  DELETE_ACCOUNT: "/api/v1/user/deleteAccount",
  GET_NOTIFICATIONS_ACTIVITY: "/api/v1/notification/listActivity",
  GET_READ_STATUS_NOTIFICATION: "/api/v1/notification/readStatus",
  GET_LIST_NOTIFICATIONS: "/api/v1/notification/listNotification",
  GET_READ_NOTIFICATION: "/api/v1/notification/readNotification",
  DELETE_NOTIFICATION: "/api/v1/notification/deleteNotification",
  CLEAR_NOTIFICATION: "/api/v1/notification/clearNotification",
  GET_REFFERAL: "/api/v1/admin/userReferralList",
  GET_REFFERAL_USER: "/api/v1/user/myCodesUser",
  GET_REWARD_HISTORY: "/api/v1/user/rewardHistory",
  GET_TWITTER: "/api/v1/admin/result",
};

export const CAMPAIGNS_API_ENDPOINT = {
  GET_CAMPAIGNS: "/api/v1/campaign/listCampaignLP",
  GET_CAMPAIGNS_DASHBOARD: "/api/v1/campaign/userDashBoard",
  GET_CAMPAIGN_BY_ID: "/api/v1/campaign/viewCampaign",
  GET_RECOMMENDED_CAMPAIGNS: "/api/v1/campaign/recommendedCampaigns",
  CREATE_CAMPAIGN: "/api/v1/campaign/addCampaign",
  UPDATE_CAMPAIGN: "/api/v1/campaign/editCampaign",
  CHANGE_CAMPAIGN_STATUS: "/api/v1/campaign/changeStatusCampaign",
  CLAIM_CAMPAIGN: "/api/v1/campaign/claimReward",
  VIEW_SOCIAL_CREDNETIALS: "/api/v1/campaign/viewSocialCredentials",
  Update_Media_CREDNETIALS: "/api/v1/campaign/updateMediaCredentials",
  DISCONNECT_SOCIAL_MEDIA: "/api/v1/campaign/disconnectSocialMedia",
  getBinGoldPrice: "/api/v1/campaign/getBinGoldPrice",
  ADD_REDEEM_CODE: "/api/v1/campaign/redeemCode",
  GET_CODES: "/api/v1/campaign/listCodes",
  GENRATE_CODES: "/api/v1/campaign/generateCode",
  GET_ASSIGNED_CAMPAIGNS: "/api/v1/campaign/listCampaignAssigned",
};

export const TASKS_API_ENDPOINT = {
  GET_TASKS: "/api/v1/campaign/listTasks",
  CREATE_TASK: "/api/v1/campaign/addTask",
  UPDATE_TASK: "/api/v1/campaign/editTask",
  CHANGE_TASK_STATUS: "/api/v1/campaign/changeStatusTasks",
  VERIFY_TASK: "/api/v1/campaign/verifyTasks",
};

// export const USERS_API_ENDPOINT = {
//   GET_USERS: "/api/v1/admin/userList",
//   VIEW_USER: "/api/v1/admin/viewUser",
//   CHANGE_USER_STATUS: "/api/v1/admin/activeBlockUser",
//   DELETE_USER: "/api/v1/admin/deleteUser",
// };

export const TRANSACTIONS_API_ENDPOINT = {
  GET_TRANSACTIONS: "/api/v1/transaction/transactionListUser",
  GET_TRANSACTIONS_HISTORY: "/api/v1/transaction/transactionHistory",
};
